require('../res/scss/style.scss');
import 'react-notifications/lib/notifications.css';

import React from 'react';
import Immutable from 'immutable';
import { Router, browserHistory, Route, IndexRoute } from 'react-router';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux'

import createRoutes from './approute';

import configureStore from './store/configurestore';
import initialStoreState from './store/initialstorestate';

import { locationChanged } from './actions/system';

let reduxState;
//Server side generated store __REDUX_STATE__
if (window.__REDUX_STATE__) {
    try {
        reduxState = JSON.parse(decodeURI(__REDUX_STATE__));
    } catch (e) {
        console.log('error', e);
    }
}

// console.log('Redux state', reduxState);

// The state variable contains the state of our store.
// This initialStoreState is the initial client-side state of the entire store.
// (May be merged with server-side state from above in __REDUX_STATE__) TODO: The merging does not work yet. (update: i do a bit just below for translations, but is not generic)
const state = Object.assign({}, reduxState, initialStoreState);

// Merge translations from server-side store, to client side store, so that they're available immediately upon loading (so that we never get "empty" texts (unless the node-server didn't get them))
if (reduxState && reduxState.i18n && reduxState.i18n.translation && Object.keys(reduxState.i18n.translation).length > 0) {
    state.i18n.translation = reduxState.i18n.translation;
    state.i18n.translationLocale = reduxState.i18n.translationLocale;
}

// Merge auth from server-side store, to client side store, so that they're available immediately upon loading (in case of server-side login)
if (reduxState && reduxState.auth && reduxState.auth.userId) {
    Object.assign(state.auth, reduxState.auth); // copy from server-side auth to client-side auth
}

if (clientConfig.config.debug_logging)
    console.log("*****************************INITIAL STORE STATE:", state);

//Can pass in initial state
/*  state*/
const store = configureStore(browserHistory, state);
//const history = syncHistoryWithStore(browserHistory, store);

if (clientConfig.config.debug_logging)
    console.log('Store', store);

browserHistory.listen((location)=> {
    //console.log('location', location);
    store.dispatch(locationChanged(location));
});

ReactDOM.render((
    <Provider store={store}>
        {createRoutes(browserHistory)}
    </Provider>),
    document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/client/src/index.js